export const getItemsFromParams = (...paramNames: string[]): string[] => {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  return paramNames.map(name => params.get(name));
};
